<template>
  <div>
    <button
      type="button"
      class="btn btn--mini btn--only-icon btn--blue circle-button float-right"
      data-toggle="modal"
      data-target="#exampleModal"
      id="refreshStackedBarBtn"
      @click="refreshStackedBar()"
    >
    <i class="fa-solid fa-eye"></i>
    </button>
    <br>
    <div ref="graphContainer" class="myStackedBar">
      <div class="modal-body">
        <h4>
          {{ titleGraph }}
        </h4>
        <bar-line-chart
          :ref="stackedBarRef"
          :url="url"
          :string-parameters="stringParameters"
        >
        </bar-line-chart>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      stackedBarRef: "",
      hasRendered: false,
      visibilityObserver: null,
    };
  },
  mounted() {
    this.stackedBarRef = "bar-line-toogle" + this.refBar;

    this.$nextTick(() => {
      this.observeVisibility();
    });
  },
  beforeDestroy() {
    this.disconnectVisibilityObserver();
  },
  methods: {
    observeVisibility() {
      if (!window.IntersectionObserver || !this.$el) {
        return;
      }

      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          const isVisible = entries.some((entry) => entry.isIntersecting);

          if (isVisible && !this.hasRendered) {
            this.openAndRender();
          }
        },
        {
          threshold: 0.1,
        },
      );

      this.visibilityObserver.observe(this.$el);
    },
    disconnectVisibilityObserver() {
      if (this.visibilityObserver) {
        this.visibilityObserver.disconnect();
        this.visibilityObserver = null;
      }
    },
    openContainer() {
      if (!this.$refs.graphContainer) {
        return;
      }

      this.$refs.graphContainer.style.visibility = "visible";
      this.$refs.graphContainer.style.height = "500px";
    },
    closeContainer() {
      if (!this.$refs.graphContainer) {
        return;
      }

      this.$refs.graphContainer.style.visibility = "hidden";
      this.$refs.graphContainer.style.height = "0px";
    },
    openAndRender() {
      this.openContainer();
      this.fetchAndRenderGraph();
    },
    fetchAndRenderGraph() {
      if (!this.$refs[this.stackedBarRef]) {
        return;
      }

      let url = this.url;
      if (this.stringParameters != null && this.stringParameters != "") {
        url += "?" + this.stringParameters;
      }

      app.__vue__.appendLoader();
      axios
        .get(url)
        .then((response) => {
          this.$refs[this.stackedBarRef].drawBarLineGraph(response.data);
          this.hasRendered = true;
        })
        .finally(() => {
          app.__vue__.removeLoader();
        });
    },
    refreshStackedBar() {
      if (!this.$refs.graphContainer) {
        return;
      }

      if (this.$refs.graphContainer.style.visibility === "visible") {
        this.closeContainer();
      } else {
        this.openAndRender();
      }
    },
  },
  props: {
    refBar: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    stringParameters: {
      type: String,
      required: false,
    },
    titleGraph: {
      type: String,
      required: false,
      default: ''
    },
    buttonCollpaseDescprition: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
.myStackedBar {
  visibility: hidden;
  height: 0px;
}
</style>